import React from 'react'
import { Col, Collapse, Row, Icon } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Scrollbars } from 'react-custom-scrollbars';
import styled from "styled-components";
import styles from "./Modal.module.scss";
// Components
import Container from "../../../../containers/Container";
import Organization from '../../../../components/License/Organization'
import LicenseResult from '../../../../components/License/LicenseResult'
import ConstructionInfo from '../../../../components/License/ConstructionInfo'
import GioiHanThongSoView from '../../../../components/AttachTable/GioiHanThongSo/View'
import Licenses from '../../../../components/CongTrinh/GiayPhep/View'
import typo from '../../../../constants/dictionaries'
import helper from "../../../../helper/helper";
import HangMucTableView from '../../../../components/CongTrinh/HangMuc/View'
import FileDinhKemView from '../../../../components/CongTrinh/FileDinhKem/View'
import TTKT from "../../../../components/AttachTable/TTKT/Table";
import TCQKTSD from "../../../../components/AttachTable/TCQKTSD/Table";
import ThamSoHC from "../../../../components/AttachTable/ThamSoHC/View";
import Constant from '../../../../constants/constant';
import Button from "../../../../components/Buttons"
const { Panel } = Collapse;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
class SurfaceMining extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      congTrinh: {},
      loaiCT: undefined,
      tenCT: undefined
    }
  }

  componentDidMount() {
    const { data } = this.props
    this.setState({
      data: data,
      tenCT: data.tenLoaiCongTrinh
    })
    if (data.ctnM_ThuyDien) {
      this.setState({
        congTrinh: data.ctnM_ThuyDien,
        loaiCT: 3
      })
    } else if (data.ctnM_HoChua) {
      this.setState({
        congTrinh: data.ctnM_HoChua,
        loaiCT: 4
      })
    } else if (data.ctnM_BaiDap) {
      this.setState({
        congTrinh: data.ctnM_BaiDap,
        loaiCT: 5
      })
    } else if (data.ctnM_TramBom) {
      this.setState({
        congTrinh: data.ctnM_TramBom,
        loaiCT: 6
      })
    } else if (data.ctnM_Cong) {
      this.setState({
        congTrinh: data.ctnM_Cong,
        loaiCT: 7
      })
    } else if (data.ctnM_TramCapNuoc) {
      this.setState({
        congTrinh: data.ctnM_TramCapNuoc,
        loaiCT: 8
      })
    } else if (data.ctnM_NhaMayNuoc) {
      this.setState({
        congTrinh: data.ctnM_NhaMayNuoc,
        loaiCT: 9
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data } = this.props
    if (prevProps.data !== data) {
      this.setState({
        data: data,
        tenCT: data.tenLoaiCongTrinh
      })
      if (data.ctnM_ThuyDien) {
        this.setState({
          congTrinh: data.ctnM_ThuyDien,
          loaiCT: 3
        })
      } else if (data.ctnM_HoChua) {
        this.setState({
          congTrinh: data.ctnM_HoChua,
          loaiCT: 4
        })
      } else if (data.ctnM_BaiDap) {
        this.setState({
          congTrinh: data.ctnM_BaiDap,
          loaiCT: 5
        })
      } else if (data.ctnM_TramBom) {
        this.setState({
          congTrinh: data.ctnM_TramBom,
          loaiCT: 6
        })
      } else if (data.ctnM_Cong) {
        this.setState({
          congTrinh: data.ctnM_Cong,
          loaiCT: 7
        })
      } else if (data.ctnM_TramCapNuoc) {
        this.setState({
          congTrinh: data.ctnM_TramCapNuoc,
          loaiCT: 8
        })
      } else if (data.ctnM_NhaMayNuoc) {
        this.setState({
          congTrinh: data.ctnM_NhaMayNuoc,
          loaiCT: 9
        })
      }
    }
  }

  render() {
    const { handleCloseModal } = this.props
    const { data, congTrinh, loaiCT, tenCT } = this.state;
    const { ctnM_GiayPhepCongTrinh, giayPhepHis, hangMucs, hoSoXinCapPheps, tsHoChuas, thanhTra_KiemTras, tienCapQuyens, thanhTras, bvpckP_View } = data;
    const ttkts = thanhTra_KiemTras ? JSON.parse(thanhTra_KiemTras) : [];
    const tcqs = tienCapQuyens ? JSON.parse(tienCapQuyens) : [];
    let bvkp = [];
    const bhvs = bvpckP_View ? bvkp.concat(bvpckP_View) : []
    return (
      <Scrollbars ref="scrollbars" style={{ height: window.innerHeight * 0.8 }} autoHeightMax={window.innerHeight} autoHide autoHideTimeout={1000} autoHideDuration={200}>
        <Container style={{ padding: 20 }}>
          {data.soGiayPhep &&
            <Row type="flex">
              <Col span={12} style={{ paddingRight: 10 }}>
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_license_organization, 1)}</a>} key="1">
                    <Organization data={data} />
                  </Panel>
                </Collapse>
              </Col>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_lichsu, 2)}</a>} key="1">
                    <Licenses dataSource={giayPhepHis ? giayPhepHis : []} />
                  </Panel>
                </Collapse>
              </Col>
            </Row>}
          {data.soGiayPhep && <div className="mt-20" />}
          <Row type="flex">
            {data.soGiayPhep &&
              <Col span={12} style={{ paddingRight: 10 }}>
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_ketQuaGP, 3)}</a>} key="1">
                    <LicenseResult data={data} />
                  </Panel>
                </Collapse>
              </Col>}
            <Col span={12} style={{ paddingLeft: 10 }}>
              <Collapse bordered={false} defaultActiveKey={['1']}>
                <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_ct_info, data.soGiayPhep ? 4 : 1)}</a>} key="1">
                  <ConstructionInfo
                    congTrinh={congTrinh}
                    loaiCT={loaiCT}
                    banDo={data.soGiayPhep ? "Đã được cấp phép" : "Chưa được cấp phép"}
                    tenCT={tenCT}
                  />
                </Panel>
              </Collapse>
            </Col>
            {!data.soGiayPhep &&
              <Col span={12} style={{ paddingLeft: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_hangMucCongTrinh, 1.1)} </a>
                <HangMucTableView dataSource={congTrinh ? congTrinh.hangMucs : []} />
                <a>{helper.generateIndexForLabel(typo.cscore_thamSoHC, 1.2)} </a>
                <ThamSoHC mode="presentation" dataSource={tsHoChuas || []} />
              </Col>}
          </Row>
          <div className="mt-20" />
          {data.soGiayPhep &&
            <Row>
              <Col span={12} style={{ paddingRight: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_tcqktsd, 3.1)} </a>
                <TCQKTSD dataSource={tcqs || []} mode="presentation" />
              </Col>
            </Row>}
          <div className="mt-20" />
          {data.soGiayPhep &&
            <Row>
              <Col span={12} style={{ paddingRight: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_ttkt, 3.3)} </a>
                <TTKT mode="presentation" dataSource={ttkts || []} />

              </Col>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_fileDinhkem, 3.4)} </a>
                <FileDinhKemView mode="presentation" dataSource={hoSoXinCapPheps || []} />
              </Col>
            </Row>}
          <div className="mt-20" />
          {data.soGiayPhep &&
            <Row>
              <Col span={12} style={{ paddingRight: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_hangMucCongTrinh, 4.1)} </a>
                <HangMucTableView dataSource={congTrinh ? congTrinh.hangMucs : []} />
              </Col>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_thamSoHC, 4.2)} </a>
                <ThamSoHC mode="presentation" dataSource={tsHoChuas || []} />
              </Col>
            </Row>}
          <div className="mt-20" />
          {data.soGiayPhep &&
            <Row>
              <Collapse bordered={false} defaultActiveKey={['1']}>
                <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_Giam_Sat_khai_thac, 5)}</a>} key="1">
                  <GioiHanThongSoView giayPhepCT={data.giamSat_KTSD_NuocMat_JSON} />
                </Panel>
              </Collapse>
            </Row>}
          <ControllerButton>
            <Button
              type="cancel"
              className={styles.buttonMargin}
              onClick={handleCloseModal}
            >
              <Icon type="arrow-right" />
              {typo.cscore_exit}
            </Button>
          </ControllerButton>
        </Container>
      </Scrollbars>
    )
  }
}

SurfaceMining.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(SurfaceMining)